import React, { useEffect, useState } from 'react';
import { ProfileQL, LinkerAccount } from '../../models/Profile';
import './accountSwitch.scss'

const iconMap = {
    mercadolibre: 'https://fiscalpop.sfo2.cdn.digitaloceanspaces.com/assets/ml-icon.png',
    amazon: 'https://fiscalpop.sfo2.cdn.digitaloceanspaces.com/assets/amazon-icon.png',
    fiscalpop: 'https://misventas-static.nyc3.digitaloceanspaces.com/LogoSmall.png',
    izettle: 'https://fiscalpop.sfo2.cdn.digitaloceanspaces.com/assets/izettle-icon.png',
    tiendanube: 'https://fiscalpop.sfo2.cdn.digitaloceanspaces.com/assets/TiendaNube.png',
}

function AccountSwitch({ currentUser }: { currentUser: ProfileQL }) {
    // AUTO LINK
    const [accounts, setAccounts] = useState<LinkerAccount[]>([]);
    // ---------

    // Linker Options for modal
    useEffect(() => {
        if (!!currentUser.linkSignature) {
            const origin = 'amazon'; // This changes by Platform
            const sig = currentUser.linkSignature;
            fetch(`https://binding.fiscalpop.com/app/sessions/available/${origin}?sig=${sig}`, { credentials: 'include' })
                .then(async (r) => {
                    if (!r.ok) throw new Error(await r.text()); 
                    return r.json();
                })
                .then((linkerAccounts: LinkerAccount[]) => {
                    const otherAccounts = linkerAccounts.filter(acc => !(acc.email === currentUser.amazonProfile.email && acc.origin === 'amazon'));
                    console.log('Available Accounts: ', otherAccounts);
                    setAccounts(otherAccounts);
                })
                .catch(e => {
                    // Some isolated or orphan linkers exist
                    console.error('Error fetching available sessions: ', e instanceof Error ? e.message : e);
                })
        }
    }, [currentUser]);


    // ML Uses Binder Session Redirect.
    const baseUrlByOrigin = (destination: LinkerAccount['origin']) => {
        const origin = 'amazon'; // This changes by Platform
        return `https://binding.fiscalpop.com/app/sessions/switch/${origin}/${destination}`;
    }

    const goToAccount = (acc: LinkerAccount) => {
        return () => {
            console.log('Navigate to: ', acc);
            const baseUrl = baseUrlByOrigin(acc.origin);
            const params = new URLSearchParams({
                token: acc.token,
                sig: currentUser.linkSignature,
            });
            window.location.assign(`${baseUrl}?${params}`);
        }
    }

    const renderCurrentLinker = () => {
        const rfcState = !!currentUser.fiscalpopProfile ? currentUser.fiscalpopProfile.rfc : 'Sin RFC';
        return (
            <div className="currentProfile">
                <div className="_avatar">´
                    {
                        !!currentUser?.fiscalpopProfile?.logoUrl ?
                            <img src={currentUser.fiscalpopProfile.logoUrl} alt="logo"/>
                            :
                            <img src="https://misventas-static.nyc3.digitaloceanspaces.com/LogoSmall.png?i=r0b6s6cef28"  alt="logo"/>
                    }
                </div>
                <div className="profileInfo">
                    <h3 className="_origin">{rfcState}</h3>
                    <p className="_chip">
                        Amazon
                    </p>
                    <p className="small">{currentUser.amazonProfile.email}</p>
                </div>
            </div>
        )
    }

    const renderOtherAccounts = () => {
        return accounts.map((acc, i) => {
            return (
                <div className="accountOption" onClick={goToAccount(acc)} key={i}>
                    <div className="_icon">
                        <img src={iconMap[acc.origin]} alt="Logo plataforma"/>
                    </div>
                    <div className="info">
                        <p className="_origin">{acc.origin}</p>
                        <p className="small">{acc.email}</p>
                    </div>
                </div>
            )
        })
    }

    return (
        <div id="AccountLink">
            {renderCurrentLinker()}
            {renderOtherAccounts()}
        </div>
    )
}


export default AccountSwitch;